/* eslint-disable */
/* eslint-disable quotes */
import { Switch } from '@mui/material';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { formActions } from '../../../Actions';
import ListTable from '../../../Components/ListTable/ListTable';
import storeServices from '@/Services/Form Services/store.services';
import { handleResponseStreamDownload } from '@/Helpers';
import { notificationServices } from '@/Services';
import { useAuth } from '@/Components/Auth/Login/auth';
import authActions from '@/Actions/auth.actions';

const TABLE_COLUMNS = [
	{
		title: 'Store ID',
		config: {
			type: 'DATA',
		},
	},

];

const ACTION_COLUMNS = [
	{
		title: 'View',
		config: {
			type: 'VIEW',
		},
	},
	{
		title: 'Delete',
		config: {
			type: 'DELETE',
		},
	},
];

const SPECIAL_COLUMNS = [
	{
		title: 'Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Client Store Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'SUPPORT NUMBER',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'MANAGER NAME',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'MANAGER NUMBER',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Store Open',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'MANAGER EMAIL',
		config: {
			type: 'DATA',
		},
	},
];
const COLMAP = {
	'Store ID': 'id',
	Name: 'name',
	Type: 'type',
	'Client Store Id': 'clientStoreId',
	'SUPPORT NUMBER': 'customersupport',
	'MANAGER NAME': 'managerName',
	'MANAGER NUMBER': 'managerPhone',
	'MANAGER EMAIL': 'managerEmail',
};

const StoreListPage = (props) => {
	const {
		fetchStore, data, query, deleteStore, navState, fetchUserList, userList,
	} = props;
	const { appConfig = {}, userConfig = {} } = useAuth();
	const [available, setAvailable] = useState({});
	useEffect(() => {
		fetchStore({
			entity: 'FILTERED_STORES',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		});
	}, []);

	useEffect(() => {
		if (data?.length > 0) {
			const storeMap = {};
			data.forEach((store) => {
				storeMap[store.id] = store.available;;
			});
			setAvailable(storeMap);
		}
	}, [data]);


	const handleDelete = ({ id }) => {
		deleteStore({
			entity: 'STORES',
			req: {
				params: {
					id,
				},
			},
			method: 'DELETE',
		});
	};

	const handleExport = async () => {
		try {
			const response = await storeServices.exportStoresList();
			if (response.status === 200) {
				handleResponseStreamDownload(
					response,
					`STORES_${appConfig?.companyName
						?.split(' ')
						?.join('_')
						?.toUpperCase()}.csv`
				);
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Some error occurred',
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error,
			});
		}
	};
	const handleType = (id, type) => {
		let subType = data.find((store) => store.id === id)?.subType;
		subType =
			subType === 'DARK_STORE' ? 'Dark Store' : subType?.split('_')?.join(' ');
		return (
			<div className='flex items-center gap-1 justify-start'>
				<div className='text-[12px] text-left text-capitalize'>{type}</div>
				{subType && (
					<div className='text-[12px] text-left text-capitalize text-yellow-500'>
						{' '}
						(
						{subType}
						)
					</div>
				)}
			</div>
		);
	};

	const handleRefresh = () => {
		fetchStore({
			entity: 'FILTERED_STORES',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		});
	}

	const handleStatusChange = async (e, id) => {
		const isChecked = e.target.checked;
		try {
			const response = await storeServices.storeStatusUpdate({
				storeId: id,
				action: isChecked ? 'enable' : 'disable',
			});
			if (response.status === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: 'Status updated successfully',
				});
				setAvailable(prev => ({ ...prev, [id]: isChecked }));
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response.message,
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error,
			});
		}
	};

	const SPECIAL_ITEMS = {
		'Store ID': (value, obj) => {
			return <div className='text-[12px] text-left'>{value}</div>;
		},
		Name: (id, name) => {
			const item = data?.find((item) => String(item?.id) === String(id));
			return (
				<div className='text-[12px] text-left'>
					{name}
					{item?.shortName && item?.shortName !== name
						? ` (${item.shortName})`
						: ''}
				</div>
			);
		},
		'Client Store Id': (id, clientStoreId) => {
			return <div className='text-[12px] text-left'>{clientStoreId}</div>;
		},
		Type: (id, type) => {
			return handleType(id, type);
		},
		'SUPPORT NUMBER': (id, supportNumber) => {
			return <div className='text-[12px] text-left'>{supportNumber}</div>;
		},
		'MANAGER NAME': (id, managerName) => {
			return <div className='text-[12px] text-left'>{managerName}</div>;
		},
		'MANAGER NUMBER': (id, managerNumber) => {
			return <div className='text-[12px] text-left'>{managerNumber}</div>;
		},
		'MANAGER EMAIL': (id, managerEmail) => {
			return <div className='text-[12px] text-left'>{managerEmail?.split(',')?.join(' ')}</div>;
		},
		'Store Open': (id) => {
			const obj = data.find((item) => item?.id == id);
			if (obj?.type === 'RETAIL') {
				return <div className='text-[12px] text-left'>{Boolean(available[id]) ? 'Yes' : 'No'}</div>;
				// return (
				// 	<Switch
				// 		name='status'
				// 		checked={Boolean(available[id])}
				// 		size='small'
				// 		color='primary'
				// 		onChange={(e) => handleStatusChange(e, id)}
				// 		inputProps={{
				// 			'data-id': id,
				// 			'data-type': 'COMBO',
				// 		}}
				// 	/>
				// );
			}
			return null;
		},
	};

	return (
		<div className='list-page-root'>
			<ListTable
				// fixedHeaderTop={0}
				colMap={COLMAP}
				columns={TABLE_COLUMNS}
				data={data
					.filter((store) => {
						return (
							store.name
								.toLowerCase()
								.indexOf(query.trim().toLowerCase()) !== -1
						);
					})
					.map((store) => {
						return {
							...store,
							_name: store?.[COLMAP?.Name],
						};
					})}
				actions={[...SPECIAL_COLUMNS, ...ACTION_COLUMNS]}
				special={SPECIAL_ITEMS}
				handleDelete={handleDelete}
				onExportClick={handleExport}
				handleRefresh={handleRefresh}
				showRefreshBtn={true}
			/>
		</div>
	);
};

const mapStateToProps = (state) => {
	const data = state.form.FILTERED_STORES.data.LIST;
	const { userPermissions, navState } = state.navigation;
	const { userList } = state?.auth;
	return {
		data,
		userPermissions,
		navState,
		userList,
	};
};

const mapDispatchToProps = {
	fetchStore: formActions.gateway,
	deleteStore: formActions.gateway,
	fetchUserList: authActions?.fetchUserList,
};

export default connect(mapStateToProps, mapDispatchToProps)(StoreListPage);
